import React from 'react'
import { Box, PageTitle } from '@perk-ui/core'

import TableauView from '../../components/TableauView'
import queryClient from '../../config/react-query'
import { useUser } from '../../features/auth/AuthContext'
// import { useUser } from '../../features/auth/AuthContext'
import QueryKeys from '../../features/query-hooks/QueryKeys'

interface RawDataProps {}

const RawData: React.FC<RawDataProps> = () => {
  const currentUser = useUser()
  const accessUserTableauSubscription =
    currentUser?.accessUser?.sponsor?.subscriptionPlan || ''
  queryClient.invalidateQueries(
    QueryKeys.tableauToken(
      'raw-data',
      'views/Sponsor_ACCESSPremium/StandardExplorer',
    ),
  )

  const getWorkbookUrl = () => {
    switch (accessUserTableauSubscription) {
      case 'basic':
        // return 'views/access_raw_data_basic/BasicRawDataHome'
        return ''
      case 'standard':
        return 'views/raw_data_standard/StandardRawDataSummary'
      case 'premium':
        return 'views/raw_data_premium/PremiumRawDataSummary'
      default:
        return ''
    }
  }

  const rawDataTableauParameters = [
    {
      key: 'parameter_select_subscription_type',
      value: 'ACCESS',
    },
    // {
    //   key: 'parameter_select_sponsor_id',
    //   value: currentUser?.accessUser?.sponsorId,
    // },
    // {
    //   key: 'parameter_select_sponsored_user_id',
    //   value: currentUser?.accessUser?.id,
    // },
  ]

  return (
    <Box p={3}>
      <PageTitle title="Raw Data" />
      {getWorkbookUrl() && (
        <TableauView
          src={getWorkbookUrl()}
          toolbar="top"
          hideTabs={false}
          section="raw-data"
          parameters={rawDataTableauParameters}
        />
      )}
    </Box>
  )
}

export default RawData
